import React from 'react';
import PropTypes from 'prop-types';

import Button from 'UI/Button';

import { UploadIcon } from "@heroicons/react/solid";

export default class UploadButton extends React.Component
{
    static propTypes = {
        onClick: PropTypes.func.isRequired
    };

    render()
    {
        return <Button className='space-x-2' type='primary' onClick={this.props.onClick}>
            <UploadIcon className='h-4' />
            <span>
                Upload
            </span>
        </Button>;
    }
}
